export default __webpack_public_path__ + "static/media/corro-enrotllador.51e6fcf2.png";